// ==============================|| OVERRIDES - DATA GRID ||============================== //

export default function DataGrid(theme) {
  const isDark = theme.palette.mode === 'dark';
  const headerBackground = isDark ? theme.palette.action.hover : theme.palette.grey[50];
  const rowHoverBackground = isDark ? theme.palette.action.hover : theme.palette.grey[50];

  return {
    MuiDataGrid: {
      defaultProps: {
        disableColumnMenu: true
      },
      styleOverrides: {
        root: {
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 8,
          backgroundColor: theme.palette.background.paper,
          overflow: 'hidden'
        },
        columnHeaders: {
          backgroundColor: headerBackground,
          color: theme.palette.text.secondary,
          fontWeight: 600,
          borderBottom: `1px solid ${theme.palette.divider}`
        },
        columnSeparator: {
          display: 'none'
        },
        row: {
          borderTop: `1px solid ${theme.palette.divider}`,
          '&:hover': {
            backgroundColor: rowHoverBackground
          }
        },
        cell: {
          color: theme.palette.text.primary,
          fontSize: '0.875rem',
          padding: '0 12px',
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          borderBottom: 'none',
          '&:focus, &:focus-within': {
            outline: 'none'
          }
        },
        footerContainer: {
          backgroundColor: theme.palette.background.paper,
          borderTop: `1px solid ${theme.palette.divider}`
        }
      }
    }
  };
}
